// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Images/preloader.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preloaderWrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}
.preloaderWrapper .preloader {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 90px;
  height: 100px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.preloaderWrapper .preloader2 {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #c11b2f;
  border-radius: 50%;
  width: 180px;
  height: 180px;
  animation: spin 1s ease-in-out infinite;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .preloaderWrapper .preloader {
    width: 70px;
    height: 80px;
  }
  .preloaderWrapper .preloader2 {
    width: 160px;
    height: 160px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomComponents/FullScreenLoader/FullScreenLoader.less"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AADF;AALA;EAQI,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EAEA,WAAA;EACA,aAAA;EAEA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAFJ;AAnBA;EAwBI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAFJ;AAMA;EACE;IACE,uBAAA;EAJF;EAMA;IACE,yBAAA;EAJF;AACF;AA0CA;EACE;IAEI,WAAA;IACA,YAAA;EAzCJ;EAsCA;IAMI,YAAA;IACA,aAAA;EAzCJ;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n\n.preloaderWrapper {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: @white-color;\n  .preloader {\n    background-image: url(\"./../../../assets/Images/preloader.png\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    margin: auto;\n    width: 90px;\n    height: 100px;\n\n    position: absolute;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n  .preloader2 {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid @primary-color;\n    border-radius: 50%;\n    width: 180px;\n    height: 180px;\n    animation: spin 1s ease-in-out infinite;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .preloaderWrapper {\n    .preloader {\n      width: 70px;\n      height: 80px;\n    }\n    .preloader2 {\n      width: 160px;\n      height: 160px;\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
